import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import FadeInFromLeft from '../components/Welcome/FadeInFromLeft';

const colors = {
  mainBlue: "#061941",
  xanthous: "#F2AF29",
  isabelline: "#F4F3EE",
  carrieban: "#3C6E71",
  cafeNoir: "#583E23",
};

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
        email
      });

      setMessage(response.data.message);
      setEmail(''); // Clear email for security
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        minWidth: "100vw",
        background: `linear-gradient(120deg, ${colors.mainBlue} 70%, ${colors.xanthous} 92%, ${colors.xanthous} 100%)`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <FadeInFromLeft>
        <div
          style={{
            width: "100%",
            maxWidth: "420px",
            background: colors.isabelline,
            borderRadius: "16px",
            boxShadow: `0 4px 24px 0 ${colors.cafeNoir}22`,
            padding: "2.25rem 2rem 2rem 2rem",
          }}
        >
          <h2
            style={{
              fontSize: "2rem",
              fontWeight: 700,
              fontFamily: "Poppins, Segoe UI, Arial, sans-serif",
              textAlign: "center",
              color: colors.mainBlue,
              marginBottom: "1.7rem",
              letterSpacing: "1px",
            }}
          >
            Forgot Password
          </h2>

          <p
            style={{
              textAlign: "center",
              color: colors.carrieban,
              marginBottom: "2rem",
              fontSize: "0.95rem",
              lineHeight: "1.5",
            }}
          >
            Enter your email address and we'll send you a link to reset your password.
          </p>

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
            <div>
              <label
                htmlFor="email"
                style={{ display: "block", fontWeight: 600, color: colors.carrieban, marginBottom: ".5rem", fontSize: ".98rem" }}
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                style={{
                  width: "100%",
                  padding: "12px 16px",
                  border: `1.7px solid ${colors.carrieban}99`,
                  borderRadius: "10px",
                  fontSize: "1rem",
                  fontFamily: "inherit",
                  background: "#fff",
                  color: colors.mainBlue,
                  outline: "none",
                  transition: "border 0.13s"
                }}
                onFocus={e => (e.target.style.border = `1.7px solid ${colors.xanthous}`)}
                onBlur={e => (e.target.style.border = `1.7px solid ${colors.carrieban}99`)}
              />
            </div>

            {error && (
              <div
                style={{
                  background: "linear-gradient(135deg, #ffe6e6 0%, #ffcccc 100%)",
                  color: "#d63031",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  border: "2px solid #ff7675",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                {error}
              </div>
            )}

            {message && (
              <div
                style={{
                  background: "linear-gradient(135deg, #e8f5e8 0%, #d4edda 100%)",
                  color: "#00b894",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  border: "2px solid #00b894",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textAlign: "center",
                }}
              >
                {message}
              </div>
            )}

            <button
              type="submit"
              disabled={loading || !email}
              style={{
                width: "100%",
                marginTop: "1.5rem",
                background: loading ? "#ccc" : colors.xanthous,
                color: colors.mainBlue,
                padding: "1rem 0",
                borderRadius: "10px",
                fontWeight: 700,
                fontSize: "1.15rem",
                border: "none",
                cursor: loading ? "not-allowed" : "pointer",
                transition: "background 0.12s, color 0.12s",
                boxShadow: `0 2px 8px 0 ${colors.xanthous}33`
              }}
              aria-label="Send Reset Link"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>

          <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
            <button
              onClick={() => navigate('/login')}
              style={{
                background: "none",
                border: "none",
                color: colors.carrieban,
                textDecoration: "none",
                fontSize: "0.9rem",
                fontWeight: 500,
                cursor: "pointer",
                transition: "color 0.2s"
              }}
              onMouseOver={(e) => e.target.style.color = colors.xanthous}
              onMouseOut={(e) => e.target.style.color = colors.carrieban}
            >
              ← Back to Login
            </button>
          </div>
        </div>
      </FadeInFromLeft>
    </div>
  );
}
